import { Capacitor } from '@capacitor/core';
import { Geolocation } from '@capacitor/geolocation';

const platform = Capacitor.getPlatform();
const GEO_LOCATION = platform === 'web' ? navigator.geolocation : Geolocation;

export default GEO_LOCATION;
